import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Select } from 'antd';
import API_URL from '../../../common/url';
import Fetch from '../../../common/Fetch';
import AssessmentSheet from '../Component/AssessmentSheet';
import SideNav from '../SideNav';
import { saveParams } from '../../../actions/noticeActions';

const { TabPane } = Tabs;
const { Option } = Select;
const TYPE = {
    'FIRST_EVALUATE': '0',
    'SECOND_EVALUATE': '1',
    'NEW_INDEPENDENT_EVALUATE': '2',
};

class QualityAssessmentSheet extends Component {
    constructor(props) {
        super(props);
        const { params } = props;
        const { type = 'FIRST_EVALUATE', userTeacherId } = params || {};
        this.state = {
            loading: false,
            list: [],
            userTeacherId,
            activeKey: TYPE[type],
            panes: [{
                title: '第一阶段报告评估',
                key: '0',
                content: this.getContent,
            }, {
                title: '第二阶段报告评估',
                key: '1',
                content: this.getContent,
            }, {
                title: '新人独立承接项目评估',
                key: '2',
                content: this.getContent,
            }],
        };
    }

    componentDidMount() {
        this.queryTeacher();
    }

    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({
            type: undefined,
            userTeacherId: undefined,
        });
    }

    queryTeacher = () => {
        const { userId } = sessionStorage;
        Fetch.post(API_URL.user.queryUserTeacherByUserId, {
            userId
        }).then(res => {
            const { list } = res;
            const { userTeacherId } = this.state;
            const params = {};
            if (!userTeacherId && (list || []).length) {
                const teacher = list.find(i => i.isMain == 1);
                params.userTeacherId = (teacher || {}).userTeacherId;
            }
            this.setState({
                list,
                ...params,
            });
        }).catch(err => {
            console.error(err);
        });
    }

    handleSelectChange = (value) => {
        this.setState({
            activeKey: '0',
            userTeacherId: value,
        });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    getContent = (key) => {
        const { activeKey, userTeacherId } = this.state;
        if (activeKey == key) {
            return <AssessmentSheet userTeacherId={userTeacherId} type={activeKey} />;
        } else {
            return null;
        }
    }

    render() {
        const { panes, activeKey, list, userTeacherId } = this.state;
        const teacherOptions = (list || []).map(i => <Option key={i.userTeacherId}>{i.teacherName}[{i.teacherCode}]{i.isMain == 1 && '(主)'}</Option>);
        return (
            <div className="content">
                <SideNav selectKey="qualityAssessmentSheet" />
                <div className="main">
                    <div className="search-bar">
                        <div className="search-item">
                            <label className="ui-label">带教老师</label>
                            <Select
                                style={{ width: 150 }}
                                placeholder="请选择"
                                value={userTeacherId ? String(userTeacherId) : undefined}
                                onChange={(value) => this.handleSelectChange(value, 'userTeacherId')}
                            >
                                {teacherOptions}
                            </Select>
                        </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                            {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content(pane.key)}</TabPane>)}
                        </Tabs>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QualityAssessmentSheet);


// WEBPACK FOOTER //
// ./src/components/teachingManagement/qualityAssessmentSheet/index.js